/**
 * The zod schema for the design 5.1 error envelope — it crosses a wire, so design 12.2
 * requires a schema alongside the type.
 */
import { z } from "zod";
import { ERROR_CODE } from "./code.js";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export const ErrorCodeSchema = z.enum(ERROR_CODE);
export const ErrorBodySchema = z
    .object({
    code: ErrorCodeSchema,
    message: z.string().min(1),
    field: z.string().min(1).nullable(),
    /** A UUID v7, present on every response and in every log line (design 9.2). */
    request_id: z.string().regex(UUID, "must be a UUID"),
})
    .strict();
export const ErrorEnvelopeSchema = z
    .object({ error: ErrorBodySchema })
    .strict();
//# sourceMappingURL=envelope.schema.js.map